import React, { useEffect, useState } from "react";
import axios from "axios";
import Coin from "../assets/images/coin.svg";
import Cart from "../assets/images/Home/Cart.svg";
import Box from "../assets/images/Home/Box.svg";
import Arrow from "../assets/images/Home/Arrow.svg";
import Wallet from "../assets/images/Home/Wallet.svg";
import Piechart from "../assets/images/Home/Piechart.svg";
import Plus from "../assets/images/Home/Plus.svg";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { GoDownload } from "react-icons/go";
import QRCode from "qrcode.react"; // Import QR code library
import { saveAs } from "file-saver";
import PayAsYouGO from "../assets/images/Home.png";
import { ImCross } from "react-icons/im";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import Bar1 from "./Bar1";

// Extend dayjs with plugins
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);



const PlanCountRegionwise = () => {
  const [planData, setPlanData] = useState([]);
  const [purchasePlanData, setPurchasePlanData] = useState([]);
  const [walletData, setWalletData] = useState(null);
  const [sessionToken, setSessionToken] = useState(null);
  const [partnerCode, setPartnerCode] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Initialize with current month
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [userRole, setUserRole] = useState(null); // State for user role
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [greeting, setGreeting] = useState("");
  const [data, setData] = useState([]);
  const [salesFilter, setSalesFilter] = useState("last7");
  const [ordersFilter, setOrdersFilter] = useState("last7");
  const [graphFilter, setGraphFilter] = useState("last30");
  const [salesData, setSalesData] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [filter, setFilter] = useState(""); // State to manage dropdown filter
 
 
 
 
   // Today's specific counts
   const [todayOrders, setTodayOrders] = useState(0);
   const [todaySales, setTodaySales] = useState(0);

  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const role = localStorage.getItem("role");

  useEffect(() => {
    const hour = new Date().getHours();

    if (hour < 12) {
      setGreeting("Good Morning");
    } else if (hour < 17) {
      setGreeting("Good Afternoon");
    } else {
      setGreeting("Good Evening");
    }
  }, []);
  useEffect(() => {
    // Fetch user role from localStorage
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  const navigate = useNavigate();

  const handletopups = () => {
    navigate("/AddmoreBalance");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const partnerCode = localStorage.getItem("partnerCode");

    if (token) {
      axios
        .get(`${apiUrl}ESIM/Get_plancount_regionwise?flag=1`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setPlanData(response.data.planlists);
          }
        })
        .catch((error) => {
          console.error("Error fetching the data", error);
        });

      axios
        .get(
          `${apiUrl}ESIM/partner_purchaseplan?partnercode=${partnerCode}&month=${selectedMonth}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            setPurchasePlanData(response.data.purchseplanlist);
          }
        })
        .catch((error) => {
          console.error("Error fetching the purchase plan data", error);
        });
    } else {
      console.error("No token found in session storage");
    }
  }, [selectedMonth]);

  useEffect(() => {
    const fetchSessionData = () => {
      const storedSessionToken = localStorage.getItem("token");
      const storedPartnerCode = localStorage.getItem("partnerCode");
      const storedRole = localStorage.getItem("role");

      if (storedSessionToken && storedPartnerCode && storedRole) {
        setSessionToken(storedSessionToken);
        setPartnerCode(storedPartnerCode);
        setIsAdmin(storedRole === "admin");
      } else {
        console.error("Session data not found");
      }
    };

    fetchSessionData();
  }, []);

  useEffect(() => {
    const fetchWalletData = async () => {
      const sessionToken = localStorage.getItem("token");
      const partnerCode = localStorage.getItem("partnerCode");
      try {
        const response = await axios.get(
          `${apiUrl}ESIMGOPartner/get_wallet_invidual?partnercode=${partnerCode}`,
          {
            headers: {
              Authorization: `Bearer ${sessionToken}`,
            },
          }
        );
        setWalletData(response.data.getindividualwallet[0]);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      }
    };

    fetchWalletData();
  }, [sessionToken, partnerCode]);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };
  const handleDownload = (lpacode) => {
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${lpacode}&size=200x200`;
    saveAs(qrCodeUrl, `QR_${lpacode}.png`);
  };

  useEffect(() => {
    const fetchReportData = async () => {
      const fromDate = dayjs().subtract(60, "day").format("MM/DD/YYYY"); // Fetch for last 60 days
      const toDate = dayjs().format("MM/DD/YYYY");
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_purchasereport_sourcewise?flag=3&fromdate=${encodeURIComponent(
            fromDate
          )}&todate=${encodeURIComponent(toDate)}&partnercode=${partnerCode}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.isSuccess) {
          setReportData(data.partnersale);
          setData(data.partnersale); // <-- FIX: populate `data` used by sales/orders/graph
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);
 const filterByRange = (rawData, type) => {
    const now = dayjs();
    const today = now.startOf("day");
    
    switch (type) {
      case "today":
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isSame(today, "day");
        });
      
      case "yesterday":
        const yesterday = today.subtract(1, "day");
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isSame(yesterday, "day");
        });
      
      case "last7":
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isAfter(now.subtract(7, "day"));
        });
      
      case "last30":
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isAfter(now.subtract(30, "day"));
        });
      
      case "month":
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isSame(now, "month");
        });
      
      case "lastMonth":
        const lastMonth = now.subtract(1, "month");
        return rawData.filter((item) => {
          const itemDate = dayjs(item.purchasedate, "MM/DD/YYYY HH:mm:ss");
          return itemDate.isSame(lastMonth, "month");
        });
      
      default:
        return rawData;
    }
  };

  // Calculate today's statistics whenever data changes
  useEffect(() => {
    if (data.length > 0) {
      const todayData = filterByRange(data, "today");
      setTodayOrders(todayData.length);
      setTodaySales(
        todayData.reduce((acc, curr) => acc + Number(curr.selling_price), 0)
      );
    }
  }, [data]);

  useEffect(() => {
    setSalesData(filterByRange(data, salesFilter));
  }, [salesFilter, data]);

  useEffect(() => {
    setOrdersData(filterByRange(data, ordersFilter));
  }, [ordersFilter, data]);

useEffect(() => {
  const filtered = filterByRange(data, graphFilter);

  const grouped = filtered.reduce((acc, curr) => {
    const date = dayjs(curr.purchasedate, "MM/DD/YYYY HH:mm:ss").format("MMM DD");
    const existing = acc.find((item) => item.date === date);
    if (existing) {
      existing.sales += Number(curr.selling_price);
    } else {
      acc.push({ date, sales: Number(curr.selling_price), rawDate: dayjs(curr.purchasedate, "MM/DD/YYYY HH:mm:ss") });
    }
    return acc;
  }, []);

  // Sort grouped data by rawDate
  grouped.sort((a, b) => a.rawDate - b.rawDate);

  // Remove rawDate if you don’t want it in the final graph data
  const finalData = grouped.map(({ date, sales }) => ({ date, sales }));

  setGraphData(finalData);
}, [graphFilter, data]);


  const lastTransaction =
    data.length > 0 ? `${data[0].planname}` : "No transactions";

  const lastTransactionamount =
    data.length > 0 ? ` $${data[0].selling_price}` : "No transactions";

  const totalSales = salesData.reduce(
    (acc, curr) => acc + Number(curr.selling_price),
    0
  );

  const totalOrders = ordersData.length;

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setQrModalOpen(true);
  };

  const closeModal = () => {
    setQrModalOpen(false);
    setSelectedPlan(null);
  };
  const filteredReportData = filter
    ? reportData.filter((sale) => sale.saletype === filter)
    : reportData;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    return (
      <>
        <circle
          cx={cx}
          cy={cy}
          r={5}
          fill="#8884d8"
          stroke="green"
          strokeWidth={2}
        />
        <text x={cx} y={cy - 10} fill="#333" textAnchor="middle" fontSize={12}>
          {payload.orders}
        </text>
      </>
    );
  };

  // Pagination logic
  const itemsPerPage = 5;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedPlans = purchasePlanData.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(purchasePlanData.length / itemsPerPage);

  return (
    <div className="container mx-auto ">
<h1 className="text-[22px] md:text-[28px] lg:text-[32px] text-[#2D3748] font-bold">{greeting}</h1>  
    <div className="grid grid-cols-1 md:grid-cols-4 gap-[20px] mb-[20px]">
        {/* Card 1: Total Orders */}
        <div className="bg-white rounded-xl p-6 shadow flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-[#3E436D] p-4 rounded-full">
              <img src={Cart} alt="Cart" />
            </div>
            <div className="gap-3  ">
              <h1 className="text-[22px] md:text-[12px] lg:text-[32px] text-[#3E436D] font-medium ">
                {" "}
                {totalOrders}
              </h1>
              <p className="text-sm  text-gray-600">Total Orders</p>
              <select
                value={ordersFilter}
                onChange={(e) => setOrdersFilter(e.target.value)}
                className="mt-2 p-2 border rounded"
              >
                 <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last7">Last 7 Days</option>
                <option value="last30">Last 30 Days</option>
                <option value="month">This Month</option>
                <option value="lastMonth">Last Month</option>
              </select>
            </div>
          </div>
        </div>

        {/* Card 2: Total Available Plans */}
        <div className="bg-white rounded-xl p-4 shadow flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-[#3E436D] p-4 rounded-full relative">
              <img src={Box} alt="BOx" />
              <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full" />
            </div>
            <div>
              <h1 className="text-[32px] text-[#3E436D] font-medium ">357</h1>
              <p className="text-sm text-gray-600">Total Available Plans</p>
            </div>
          </div>
        </div>

        {/* Card 3: Recent Transaction */}
        <div className="bg-white rounded-xl p-4 shadow flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-[#3E436D] p-4 rounded-full relative">
              <img src={Arrow} alt="Arrow" />
            </div>
            <div>
                               {role === "Partner" && (

              <h1 className="text-[32px] text-[#3E436D]  font-medium ">
                {lastTransactionamount}
              </h1>
                                )}

              <p className="text-sm text-gray-600">Recent Transaction</p>
              <p className="text-xs  text-gray-400">{lastTransaction}</p>
            </div>
          </div>
        </div>
        {/* Card 4: Total Spent */}
        <div className="bg-[#3E436D] text-white rounded-xl p-4 shadow flex items-center justify-between first-letter">
          <div className="flex items-center gap-4">
            <div className="bg-white p-2 rounded-full">
              <img src={Wallet} alt="Wallet" />
            </div>
            <div>
                                {role === "Partner" && (

              <h1 className="text-[32px] text-white font-semibold">
                {" "}
                ${totalSales.toFixed(2)}
              </h1>
                  )}
              <p className="text-sm text-white">Total Spent</p>
              <select
                value={salesFilter}
                onChange={(e) => setSalesFilter(e.target.value)}
                className=" text-sm border rounded px-2 py-1 focus:outline-none text-black"
              >
               <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last7">Last 7 Days</option>
                <option value="last30">Last 30 Days</option>
                <option value="month">This Month</option>
                <option value="lastMonth">Last Month</option>
              </select>{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-stretch">
        {/* Available Regional Plans */}
        <div className="w-full lg:w-1/4 p-2 flex ">
          <div className="bg-white shadow rounded-lg p-4 flex-grow flex flex-col">
            <h1 className="text-2xl font-bold mb-4 text-gray-800">
              Top Countries / Regions
            </h1>

            <div className="flex-grow overflow-auto divide-y">
              {planData.slice(0, 6).map((plan, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center py-3 px-2"
                >
                  <span className="text-gray-700 text-base font-medium">
                    {plan.regionname || "Country Plans"}
                  </span>
                  <span className="text-gray-600 text-sm font-semibold relative flex items-center gap-1">
                    <img src={Piechart} alt="piechart" />
                    {plan.plancount}
                  </span>
                </div>
              ))}
            </div>

            <h4 className="text-center text-[0.75rem] text-gray-500 mt-6">
              Top Countries / Regions Purchase Volume
            </h4>
          </div>
        </div>

        {/* Wallet or Pay As You Go */}
        <div className="w-full lg:w-1/4 p-2 flex gap-[40px]">
          <div className="bg-white shadow rounded-lg p-4 flex-grow flex flex-col justify-between  border border-[#00B074]">
            <h1 className="text-5xl font-bold mb-4 flex justify-between items-center">
              {userRole === "Partner" ? (
                <>
                  <div className="flex items-center gap-4">
                    <div className="bg-[#3E436D] p-4 rounded-full relative">
                      <img src={Coin} alt="coin" />
                    </div>
                    <div>
                      <h1 className="text-5xl text-[#3E436D] font-bold">
                        Wallet Balance{" "}
                      </h1>
                    </div>
                  </div>
                </>
              ) : (
                "Pay As You Go"
              )}
            </h1>

            <div className="text-center my-4 mb-8 mt-8 flex-grow flex items-center justify-center">
              {userRole === "Partner" ? (
                <div style={{ fontSize: "48px" }} className=" text-[#3E436D]">
                  {walletData ? (
                    <p className="text-2xl rounded-2xl p-2 bg-[#F6F6F6] font-medium">
                      ${walletData.balance}
                    </p>
                  ) : (
                    <p className="text-lg text-gray-600">Loading...</p>
                  )}
                </div>
              ) : (
                <div
                  style={{ fontSize: "2.0rem" }}
                  className="font-bold text-[#3E436D]"
                >
                  <img src={PayAsYouGO} className="mr-2 w-80 h-64" />
                </div>
              )}
            </div>

            {userRole === "Partner" && (
              <button
                className="text-[#595959] w-full flex justify-center items-center  border border-[#00B074] px-4 py-2 rounded-2xl mb-2"
                onClick={handletopups}
              >
                <img src={Plus} alt="Plus" />{" "}
                <h1 className="text-bold text-3xl">Add more balance </h1>
              </button>
            )}
          </div>
        </div>

        {/* Sales Graph */}
        <div className="w-full lg:w-2/4 p-2 flex gap-[40px]">
        <Bar1/>
        </div>
      </div>

<div className=" hidden md:block">
      <div className="mt-4 bg-white shadow rounded-t-lg p-4 flex justify-between items-center ">
        <h2 className="text-5xl font-bold ">Purchased Plans</h2>
        <div className="relative">
          <select
            className="bg-[#1ebab1] text-white p-2 rounded"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            <option value={1}>January</option>
            <option value={2}>February</option>
            <option value={3}>March</option>
            <option value={4}>April</option>
            <option value={5}>May</option>
            <option value={6}>June</option>
            <option value={7}>July</option>
            <option value={8}>August</option>
            <option value={9}>September</option>
            <option value={10}>October</option>
            <option value={11}>November</option>
            <option value={12}>December</option>
          </select>
        </div>
      </div>

      {selectedPlans.length === 0 ? (
        <p className="text-lg bg-[#ffffff] font-bold text-center h-56 text-[#000000] flex items-center justify-center">
          No Active Packages
        </p>
      ) : (
        <table className="w-full bg-white rounded-md">
          <thead>
            <tr>
              <th className="px-6 py-3 text-center">Order ID</th>
              <th className="px-6 py-3 text-center">Plan Name</th>
              {userRole == "Partner" && (
                <th className="px-6 py-3 text-center">Purchase Amount</th>
              )}
              <th className="px-6 py-3 text-center">Purchase Date</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredReportData.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <p className="text-lg font-bold">No Active Packages</p>
                </td>
              </tr>
            ) : (
              filteredReportData.map((sale, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 text-center">{sale.order_id}</td>
                  <td className="px-6 py-4 text-center">{sale.planname}</td>
                  {userRole == "Partner" && (
                    <td className="px-6 py-4 text-center">
                      ${parseFloat(sale.purchaseamount).toFixed(2)}
                    </td>
                  )}
                  <td className="px-6 py-4 text-center">{sale.purchasedate}</td>
                  <td className="px-6 py-4 flex text-center">
                    <button
                      className="text-black font-bold py-2 px-4 rounded space-x-2"
                      onClick={() => handleDownload(sale.activationCode)}
                    >
                      <GoDownload />
                    </button>
                    <button
                      className="text-black font-bold py-2 px-4 rounded space-x-2"
                      onClick={() => openModal(sale)}
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
</div>

      {/* Modal for QR Code */}
      {qrModalOpen && selectedPlan && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-8 rounded-md flex flex-row relative">
            {/* Left column */}
            <div className="flex flex-col items-start w-96">
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">Order ID:</span>{" "}
                <span className="ml-4">{selectedPlan?.order_id || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">APN:</span>{" "}
                <span className="ml-4">{selectedPlan?.apn || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">ICCID:</span>{" "}
                <span className="ml-4">{selectedPlan?.iccid || "N/A"}</span>
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <span className="font-bold">SIMPIN:</span>{" "}
                <span className="ml-4">{selectedPlan?.simpin || "N/A"}</span>
              </div>
  

               <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">For Andriod Devices:<span className="font-normal">Enter below Activation Code.</span> </h1>{" "}<br></br>
                  {selectedPlan?.activationCode || "N/A"}
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-[#c5f1f1] rounded-2xl">
                <span className="font-bold">How to Install ?</span>
                <a
                  href="https://www.airhubapp.com/info/esim-installation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-4 border-2 rounded-2xl hover:bg-blue-400 p-2 border-black"
                >
                  Step by Step Guide
                </a>
              </div>
            </div>

            {/* Right column */}
            <div className="flex flex-col items-center justify-center ml-8">
              <QRCode
                value={selectedPlan.activationCode}
                className="border-4 p-2 border-[#47a192]"
                size={200}
              />
              <button
                className="text-[#595959] flex items-center border border-black px-4 py-2 rounded mt-4"
                onClick={() => handleDownload(selectedPlan.activationCode)}
              >
                <GoDownload size={30} /> Download
              </button>
            </div>

            {/* Close button */}
            <ImCross
              size={30}
              onClick={closeModal}
              className="cursor-pointer absolute top-2 right-2"
            />
          </div>
        </div>
      )}

      <div className="bg-[#ffffff] flex justify-center">
        <div className="flex space-x-2">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`px-3 py-1 rounded ${
                index + 1 === currentPage
                  ? "bg-blue-500 text-white"
                  : "bg-white"
              }`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanCountRegionwise;